import { API } from "aws-amplify";
import { isEmpty } from "lodash";

async function createStream(stream: VideoStreamBase): Promise<VideoStream> {
  try {
    const path: string = '/streams';
    const tempStream: any = {
      ...stream
    }

    delete tempStream.kvsName
    if (isEmpty(stream.position)) {
      delete tempStream.position;
    }

    const options = {
      body: {
        ...tempStream
      }
    };

    const data = await API.post(
      'api-service',
      path,
      options
    );

    return data.data as VideoStream;

  } catch (error: any) {
    throw new Error(error.response?.data.error || error.message);
  }
}

export default createStream;
